module.exports = __webpack_public_path__ + "static/media/billboard.b7f38d24.png";